module.exports = __webpack_public_path__ + "static/media/expandingKit.3fae66e4.gif";